import { defineStore } from "pinia";

export interface State {
  mainMenuAlign?: "left" | "right";
  hideSettingsTab?: boolean;
  hideControlPanel?: boolean;
  showControlPanelExpand?: boolean;
  enableSubjectLine?: boolean;
}

export const useLayoutStore = defineStore("layout", {
  state: (): State => ({
    mainMenuAlign: "left",
    hideSettingsTab: false,
    hideControlPanel: false,
    showControlPanelExpand: false,
    enableSubjectLine: false,
  }),
  actions: {
    toggleControlPanel() {
      this.hideControlPanel = !this.hideControlPanel;
    },
  },
});
